import React, { Component } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "../../containers/common/progress_bar";
import { DoubleLeftOutlined, DoubleRightOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./index.css";

const preETaskListItemStyle = {
    margin: '15px',
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column'
};

const nameStyle = {
    padding: '10px',
    color: 'white',
    fontWeight: 'bold',
    flexGrow: '1',
    wordWrap: 'break-word',
};

const completedStyle = {
    ...nameStyle,
    backgroundColor: '#7EB941'
};

const incompletedStyle = {
    ...nameStyle,
    backgroundColor: '#AF2025'
};

const completionStyle = {
    padding: '10px',
    textAlign: 'center',
    borderLeft: '1px solid lightgrey',
    borderRight: '1px solid lightgrey',
    fontSize:'15px'
};

const viewTaskStyle = {
    padding: '10px',
    textAlign: 'center',
    border: '1px solid lightgrey'
};

const PreETaskListScrollArea = {
    margin: '20px 0',
    paddingBottom: '10px',
};

class PreETaskListItem extends Component {
    render() {
        const { project, projectId, status, ipsLocations } = this.props;
        const isPreJobTasksCompleted = (project.preJobTPercent === 100);
        const isCIPSecCompleted = (project.cipsecurityTPercent === 100);
        const cipSecurityObject = {
            showCIPSecurityTasks: project.showSecurityTasks,
            stationName: project.stationName,
            projectId: project.id,
            status: project.cipsecurityTPercent,
        };
        const preJobObject = {
            showPreJobTasks: project.preJobTPercent !== null,
            stationName: project.stationName,
            projectId: project.id,
            status: project.preJobTPercent,
        };
        const combinedProjectData = project.showSecurityTasks === 1 ? ipsLocations.concat(cipSecurityObject, preJobObject) : ipsLocations.concat(preJobObject);
        const finalSortedArray = combinedProjectData?.sort((a, b) => (a.status - b.status));
        const totalCardsCount = finalSortedArray.length;

        const renderPreETaskCard = (item, pathUrl, label) => {
            const isCompleted = (label === 'Pre-Job' ? isPreJobTasksCompleted : isCIPSecCompleted);
            return <div style={preETaskListItemStyle}>
                <div style={isCompleted ? completedStyle : incompletedStyle}>{item.stationName}</div>
                <div style={completionStyle}> {label} Tasks Complete
                    {item.status<100 ? <ProgressBar percentage={Number.parseInt(item.status)} /> : <ProgressBar percentage={item.status} color={'success'}/>}
                </div>
                <div style={viewTaskStyle}>
                    <Link
                        to={{
                            pathname: pathUrl,
                            project: project
                        }}
                        style={{ fontize: "30px" }}
                    >
                        View Tasks
                    </Link>
                </div>
            </div>
        }

        const renderPreJobAndCIP = (item) => {
            const preEJobTaskPathUrl = `/${status}/${projectId}/projecttasks/Pre-Job`;
            const preEJobCardLabel = 'Pre-Job';
            const cipSecTaskPathUrl = `/${status}/${projectId}/projecttasks/CIP Security`;
            const cipSecCardLabel = 'CIP Security';
            return <>
                {(item.showPreJobTasks) && renderPreETaskCard(item, preEJobTaskPathUrl, preEJobCardLabel)}
                {(item.showCIPSecurityTasks === 1) && renderPreETaskCard(item, cipSecTaskPathUrl, cipSecCardLabel)}
            </>
        }

        const renderIpsLocationsAlone = (item, index) => {
            return <div key={index} style={preETaskListItemStyle}>
                <div style={(item.status === 100) ? completedStyle : incompletedStyle}>{item.name}</div>
                <div style={completionStyle}> Pre Energization Tasks Complete
                    {item.status<100 ? <ProgressBar percentage={Number.parseInt(item.status)} /> : <ProgressBar percentage={item.status} color={'success'}/>}
                </div>
                <div style={viewTaskStyle}>
                    <Link
                        to={{
                            pathname: `/${status}/${projectId}/assettasks/ipslocations/${item.id}`,
                            ipsLocation: item
                        }}
                        style={{ fontize: "30px" }}
                    >
                        View Tasks
                    </Link>
                </div>
            </div>
        }


        const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
            const { carouselState: { currentSlide } } = rest;
            return (
                <div className="carousel-button-group">
                    {/* is starting slide */}
                    {(currentSlide === 0) ?
                        <LeftOutlined
                            className={'disableLeftArrow'} />
                        :
                        <DoubleLeftOutlined
                            className={'leftArrow'}
                            onClick={() => previous()} />
                    }
                    {/* is last slide */}
                    {/*
                   added logic when there is less than 4 card to show disable arrow 
                */}
                    {(currentSlide === (totalCardsCount - 4)) ||(totalCardsCount <= 4) ? 

                        <RightOutlined
                            className={'disableRightArrow'} />
                        :
                        <DoubleRightOutlined
                            className={'rightArrow'}
                            onClick={() => next()} />
                    }
                </div>
            );
        };

        const responsive = {
            superLargeDesktop: {
                // the naming can be any, depends on you.
                breakpoint: { max: 4000, min: 3000 },
                items: 4
            },
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 4
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 2
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1
            }
        };

        return (
            <div style={PreETaskListScrollArea}>
               
                <Carousel
                    arrows={false}
                    customButtonGroup={<ButtonGroup />}
                    renderButtonGroupOutside={true}
                    renderArrowsWhenDisabled={true}
                    
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={false}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    deviceType={this.props.deviceType}>
                    {finalSortedArray && finalSortedArray.map((item, index) =>
                    (<>
                        {
                            (item.stationName) ? renderPreJobAndCIP(item, index) : renderIpsLocationsAlone(item, index)
                        }
                    </>)
                    )}
                </Carousel>
            </div>
        )
    }
}

export default PreETaskListItem;